import Bowser from 'bowser';

/**
 * 支持浏览器
 *
 * 1. chrome
 * 1. safari 大于等于 11.1
 *
 * 1. 不支持 qq
 * 2. 不支持 ios 和 andorid 的 chrome
 * 3. 不支持 ie 和 edge
 * 4.
 */
export function isBrowserSupport() {
  const browser = Bowser.getParser(window.navigator.userAgent);

  const isValidBrowser = browser.satisfies({
    desktop: {
      safari: '>=11.1',
      chrome: '>=72',

      qq: false,
      qqlite: false,
      firefox: false,
      ie: false,

      edge: false,
      wechat: false,
    },
  });

  return isValidBrowser;

  // if (isFF()) {
  //   isWebRTCSupported = false;
  // } else if (isSafari()) {
  //     var iOSVersion = etiOSVersion();
  //     var safariVersion = getSafariVersion();

  //     if (iOSVersion) {
  //       if (iOSVersion[0] === 11 && iOSVersion[1] >= 1) {
  //         // do nothing
  //       } else if (iOSVersion[0] > 11) {
  //         // do nothing
  //       } else {
  //         isWebRTCSupported = false;
  //       }
  //     } else if (safariVersion) {
  //       if (safariVersion[0] === 11 && safariVersion[1] >= 1) {
  //         // do nothing
  //       } else if (safariVersion[0] > 11) {
  //         // do nothing
  //       } else {
  //         isWebRTCSupported = false;
  //       }
  //     } else {
  //       isWebRTCSupported = false;
  //     }
  //   } else if (isQQ() && !isWindows()) {
  //     isWebRTCSupported = false;
  //   } else if (isWX() || isMQQBrowser() || !foundChrome()) {
  //     isWebRTCSupported = false;
  //   } else if (isChrome()) {
  //     if (isiOS() || isAndroid()) {
  //       isWebRTCSupported = false;
  //     }
  //   } else if (isEdge() || isIE()) {
  //     isWebRTCSupported = false;
  //   }
  // }
}
